import { themeOptionFactory as mobile } from "./mobile"

export const themeOptionFactories = {
  mobile,
}
